import CanvassMap from "../Components/CanvassMap";

const CanvassMapPage = () => {
  return <CanvassMap />;
};

export default CanvassMapPage;
